import { Button, Paper, Stack, TextField, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import API from '../../../services/API'
import { GlobalContext } from '../../../App'

const SuitabilityNotes = ({ initialValue, applicationID, getApplication }) => {
  const [notes, setNotes] = useState(initialValue)
  const {setToast} = useContext(GlobalContext)


  const handleSubmit = () => {
    API.post('/update-employees-application', {
        applicationID,
        suitabilityNotes: notes
    }).then(res => {
        if (res.status === 200) {
            setToast({
                message: 'Suitability Notes Saved'
            })
            getApplication()
        }
    }).catch(e => {
        console.log(e)
        setToast({
            message: 'Unable to save notes. Please try again later.',
            severity: 'error'
        })
    })
  }

  return (
    <Stack gap={1} component={Paper} padding={1}>
      <Typography variant="title2" fontSize="1rem">
        Suitability Notes
      </Typography>
      <TextField
        multiline
        minRows={3}
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
      />
      <Button
        disabled={initialValue === notes}
        size="small"
        fullWidth
        color="success"
        variant="contained"
        onClick={handleSubmit}
      >
        Submit
      </Button>
    </Stack>
  )
}

export default SuitabilityNotes